// * Bootstrap libraries
import './_bootstrap';

(($, Drupal) => {
    Drupal.behaviors.mapSRR = {
        attach() {
            const $map = $('#map_srr');
            const members = {
                'UN': '/mitglieder/kreis-unna',
                'RE': '/mitglieder/kreis-recklinghausen',
                'WES': '/mitglieder/kreis-wesel',
                'EN': '/mitglieder/kreis-ennepe-ruhr',
                'BO': '/mitglieder/stadt-bochum',
                'BOT': '/mitglieder/stadt-bottrop',
                'DO': '/mitglieder/stadt-dortmund',
                'DU': '/mitglieder/stadt-duisburg',
                'E': '/mitglieder/stadt-essen',
                'GE': '/mitglieder/stadt-gelsenkirchen',
                'HA': '/mitglieder/stadt-hagen',
                'HAM': '/mitglieder/stadt-hamm',
                'HER': '/mitglieder/stadt-herne',
                'MH': '/mitglieder/stadt-muelheim-der-ruhr',
                'OB': '/mitglieder/stadt-oberhausen',
            }
            if ($map.length) {
                $map.find('#regions path').click(function () {
                    const region = $(this).attr('id');
                    window.location.href = members[region];
                });
            }
        }
    };
})(jQuery, Drupal);
